import { ReactNode, FC } from "react";
import { BaseComponentProps } from "../types";
import { PrimaryButton } from "./PrimaryButton";
import { SecondaryButton } from "./SecondaryButton";
import { TextButton } from "./TextButton";

type Appearance = "primary" | "secondary" | "text";

type LinkButtonProps = BaseComponentProps<
  "a",
  {
    children: ReactNode;
    appearance?: Appearance;
  }
>;

export const LinkButton: FC<LinkButtonProps> = ({
  children,
  appearance = "primary",
  ...anchorProps
}) => (
  <a {...anchorProps}>
    <Button appearance={appearance}>{children}</Button>
  </a>
);

const Button = ({
  children,
  appearance,
}: {
  children: ReactNode;
  appearance: Appearance;
}) => {
  switch (appearance) {
    case "primary":
      return <PrimaryButton>{children}</PrimaryButton>;
    case "secondary":
      return <SecondaryButton>{children}</SecondaryButton>;
    case "text":
      return <TextButton>{children}</TextButton>;
  }
};
